import { TakeActionDropdownData } from 'components/TakeActionDropdown/types/TakeActionDropdownData';
import { getMainVolopsSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainVolopsSearchRoutePath';

export const takeActionDropdownDataPt: TakeActionDropdownData = {
  search: {
    title: 'Busca',
    items: [
      {
        type: 'volop',
        title: 'Voluntariado',
        href: getMainVolopsSearchRoutePath({ lang: 'pt' }),
      },
      {
        type: 'event',
        title: 'Eventos',
        href: getMainVolopsSearchRoutePath({
          lang: 'pt',
          filters: { type: 'VOLOP', actionType: ['EVENT'] },
        }),
      },
      {
        type: 'donations',
        title: 'Doações',
        href: getMainVolopsSearchRoutePath({
          lang: 'pt',
          filters: { type: 'VOLOP', actionType: ['DONATION'] },
        }),
      },
    ],
  },
  resources: {
    title: 'Recursos',
    items: [
      {
        type: 'idealist-movement',
        title: 'Movimento Idealista',
        description:
          'Bem Vindo ao Movimento Idealista. Aqui você encontra formas de se conectar e pode conhecer o ecossistema idealista para transformação social.',
        href: '/pt/movimento',
      },
      {
        type: 'knowledge-base',
        title: 'Blog Idealista',
        description:
          'Vamos transformar nossas comunidades? Quer trabalhar no terceiro setor? Recursos e Dicas para o Transformador Social.',
        href: '/pt/blog',
      },
    ],
  },
};
